<template>
    <div>
        <slot></slot>
        
        <!-- Welcome -->
        <welcome-modal v-if="isActiveOnboarding && flow && welcome.isOpen" :flow="flow" @start="onStartOnboarding" @close="onSkipWelcomeOnboarding" />

        <!-- Select option tutorials -->
        <choice-modal v-if="isActiveOnboarding && flow && remind.isOpenChoice" :flow="flow" @continue="onContinueChoiceTutorial" />

        <!-- Reminder continue onboarding -->
        <remind-modal
            v-if="isActiveOnboarding && flow && remind.isOpen"
            :flow="flow"
            :options="remind.tutorials"
            :isRemind="remind.reminder"
            @continue="onContinueChoiceTutorial"
            @skip="onSkipRemindOnboarding"
            @select="onSelectOptionRemind"
            :loading="remind.loading" />

        <!-- Congratulation modal onboarding after the all onboarding were completed -->
        <congratulation-modal v-if="isActiveOnboarding && congratulation.isOpen" @complete="onCompleteCongratulationModal" />

        <!-- Introduce Onboardings -->
        <intro-advertising-onboarding
            v-if="isActiveOnboarding && flow && advertising.isOpen"
            :flow="flow"
            @before="onBeforeOnboardingAdvertising"
            @start="onStartOnboardingAdvertising"
            @close="onCloseOnboardingAdvertising" />
        <!-- /Introduce Onboardings -->

        <!-- Interactive with store -->
        <vue-onboarding></vue-onboarding>
        <!-- /Interactive with store -->
                    
        <user-onboarding-rating v-if="isFinishOnboardingPerPage"></user-onboarding-rating>
    </div>
</template>

<script>
import VueOnboarding from '../VueOnboarding/VueOnboarding.vue';
import WelcomeModal from './components/WelcomeModal.vue';
import IntroAdvertisingOnboarding from './components/IntroAdvertisingOnboarding.vue';
import RemindModal from './components/RemindModal.vue';
import ChoiceModal from './components/ChoiceModal.vue';
import onboardingService from '../../core/services/onboardingService';
import userOnboardingService from '../../core/services/userOnboardingService';
import CongratulationModal from '../../components/UserOnboarding/components/CongratulationModal.vue';
import UserOnboardingRating from '../UserOnboardingVersion2/UserOnboardingRating.vue';

export default {
    name: 'user-onboarding',

    components: {
        VueOnboarding,
        IntroAdvertisingOnboarding,
        RemindModal,
        WelcomeModal,
        ChoiceModal,
        CongratulationModal,
        UserOnboardingRating
    },

    props: {
        // The props to define User Onboarding should turn on or turn off
        // If you want to turn off, let to set the prop 'off' is true 
        off: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            // Modal welcome
            welcome: {
                isOpen: false,
            },

            // Modal remind
            remind: {
                isOpenChoice: false,

                isOpen: false,
                tutorials: userOnboardingService.configs.tutorials,
                reminder: true,

                loading: false,
            },

            congratulation: {
                isOpen: false,
                withEmitCompleted: false,
            },

            // Modal intro advertising tutorial
            advertising: {
                isOpen: false,
            },
            isActiveOnboarding: false
        };
    },

    computed: {
        flow() {
            const obdFlow = this.$store.state.vueOnboarding.onboarding.flow;

            return obdFlow ? obdFlow : false;
        },

        status() {
            return this.$store.state.vueOnboarding.onboarding.status;
        },

        tutorials() {
            return this.$store.state.vueOnboarding.onboarding.tutorials;
        },

        isFinishOnboarding() {
            return this.$store.state.vueOnboarding.isFinished;
        },
        
        isCompletedAll() {
            return this.$store.state.vueOnboarding.isCompletedAll;
        },
        
        isSkip() {
            return this.$store.state.vueOnboarding.isSkip;
        },

        isLogin() {
            return this.$auth.user();
        },

        isFinishOnboardingPerPage() {
            let isFinished = this.$store.state.vueOnboarding.isFinished;
            let userInfo = this.$store.state.authUser.userInfo;
            let isOnboardingPerPage = userInfo.isUserOnboardingDashboard || userInfo.isUserOnboardingCampaign || false;
            
            return isOnboardingPerPage && isFinished;
        }
    },

    watch: {
        status() {
            // Turn off onboarding
            if(this.off) return;

            switch (this.status) {
                case 'start':
                    this.onOpenWelcomeModal(true);
                    break;
                case 'hold':
                case 'processing':
                    this.onOpenRemindModal(true);
                    break;
            }
        },

        tutorials() {
            // Update remind state here
        },

        isFinishOnboarding() {
            if (this.isFinishOnboarding) {
                this.onOpenRemindModal(true);
            }
        },

        isLogin() {
            if (this.$auth.check()) {
                console.log("[mutation UserOnboarding.vue][watch][isLogin] ", "called to check and get /api/user-onboarding/trackingProcess");
                this.onGetTutorials();
            }
        },
        isFinishOnboardingPerPage() {
            if (this.isFinishOnboardingPerPage) {               
                $('body').addClass('overflow-hidden');
            } else {
                $('body').removeClass('overflow-hidden');
            }
        }
    },

    methods: {
        onOpenWelcomeModal(status) {
            this.welcome.isOpen = status;
        },

        onOpenRemindModal(status) {
            this.remind.isOpen = status;
        },

        onSetReminder(status = false) {
            this.remind.reminder = status;
        },

        onOpenChoiceModal(status) {
            this.remind.isOpenChoice = status;
        },

        onOpenAdvertising(status) {
            this.advertising.isOpen = status;
        },

        onOpenCongratulationModal(status) {
            this.congratulation.isOpen = status;
        },

        onSetCongratulationWithEmitCompleted(status = false) {
            this.congratulation.withEmitCompleted = status;
        },

        onResetDatasets() {
            this.welcome = {
                isOpen: false,
            };

            // Modal remind
            this.remind = {
                isOpenChoice: false,

                isOpen: false,
                tutorials: userOnboardingService.configs.tutorials,
                reminder: true,

                loading: false,
            };

            this.congratulation = {
                isOpen: false,
                withEmitCompleted: false,
            };

            // Modal intro advertising tutorial
            this.advertising = {
                isOpen: false,
            };
        },

        onStartOnboarding() {
            if (this.status === 'start') {
                this.onOpenWelcomeModal(false);
                this.onOpenChoiceModal(true);

                // Call api here to tracking process
                console.log('SEND API START ONBOARDING');
            }
        },

        onSkipWelcomeOnboarding() {
            if (this.status === 'start') {
                this.onOpenWelcomeModal(false);

                userOnboardingService.skip({ welcome: true, tutorial: false });
            }
        },

        onContinueChoiceTutorial({ tutorial, component }) {
            switch (component) {
                case 'remind-modal':
                    this.onOpenRemindModal(false);
                    break;
                case 'choice-modal':
                    this.onOpenChoiceModal(false);
            }

            switch (tutorial) {
                case 'advertisement':
                    this.onOpenAdvertising(true);
                    break;
                case 'create_link':
                    // Create link not have modal introduce
                    // This start will run after setSteps below compiled
                    // Event loop here
                    setTimeout(() => {
                        onboardingService.start();
                    }, 0);
                    break;
                default:
            }

            onboardingService.setSteps(userOnboardingService.configs.steps[tutorial]);
        },

        onBeforeOnboardingAdvertising() {
            // this.$router.push({ name: 'user-profile', params: { tab: 'general' } });
        },

        onStartOnboardingAdvertising() {
            this.onOpenAdvertising(false);

            setTimeout(() => {
                onboardingService.start();
            }, 600);
        },

        onCloseOnboardingAdvertising() {
            const isConfirmed = confirm('Bạn muốn tạm ngưng hướng dẫn cho người mới?');

            if (isConfirmed) {
                this.onOpenAdvertising(false);
                userOnboardingService.hold({ step: 0, tutorial: 'advertisement' });
                onboardingService.setHolding(true);
            }
        },

        /**
         * Select the option onboarding
         *
         * @param {{
         *  checked: boolean;
         *  completed: boolean;
         *  text: string;
         *  id: string;
         * }} option The option onboard
         */
        onSelectOptionRemind(option) {
            this.remind.tutorials = this.remind.tutorials.map((tutorial) => {
                if (tutorial.id === option.id) {
                    return {
                        ...option,
                        checked: true,
                    };
                }

                return {
                    ...tutorial,
                    checked: false,
                };
            });
        },

        onSkipRemindOnboarding() {
            userOnboardingService.skip({ welcome: false, tutorial: true });
            this.onOpenRemindModal(false);
        },

        onCompleteCongratulationModal() {
            this.onOpenCongratulationModal(false);
        },

        onGetTutorials() {
            // Turn off onboarding
            if(this.off) return;

            this.remind.loading = true;

            userOnboardingService
                .trackingProcess()
                .then((data) => {
                    const { is_completed_all, is_reminder, is_welcome, onboarding } = data;

                    if(is_welcome && !is_completed_all && !is_reminder) {
                        this.onOpenWelcomeModal(true);

                        this.onOpenCongratulationModal(false);
                        this.onOpenRemindModal(false);
                        this.onOpenChoiceModal(false);
                    }
                    else if (is_completed_all && this.congratulation.withEmitCompleted) {
                        this.onOpenCongratulationModal(true);

                        // Force off
                        this.onOpenRemindModal(false);
                        this.onOpenWelcomeModal(false);
                        this.onOpenChoiceModal(false);
                    } else if (!this.welcome.isOpen && !is_completed_all && is_reminder) {
                        this.onOpenRemindModal(true);
                    }

                    if (Object.keys(onboarding.tutorials || {}) !== 0) {
                        this.remind.tutorials = this.calculateResultTutorialsDisplay(onboarding.tutorials);
                    }
                })
                .finally(() => {
                    this.remind.loading = false;
                });
        },

        calculateResultTutorialsDisplay(tutorials = {}) {
            const result = this.remind.tutorials.map((tutorial) => {
                const currentTutorialOnBoarding = tutorials[tutorial.id] || false;
                const isTutorialCompleted =
                    currentTutorialOnBoarding && currentTutorialOnBoarding.status === userOnboardingService.status.completed;

                if (isTutorialCompleted) {
                    return { ...tutorial, checked: false, completed: true };
                } else {
                    return { ...tutorial, checked: false };
                }
            });

            const isLteOneTutorial = result.filter((tutorial) => !tutorial.completed).length === 1;
            if (isLteOneTutorial) {
                return result.map((tutorial) => {
                    if (!tutorial.completed) {
                        return { ...tutorial, checked: true };
                    }

                    return tutorial;
                });
            }

            return result;
        },
    },

    mounted() {
        userOnboardingService.onListenCompleted(() => {
            this.onSetReminder(false);
            this.onSetCongratulationWithEmitCompleted(true);
            this.onGetTutorials();
        });

        this.$router.afterEach((to) => {
            if(to.name === "page-login") {
                this.onResetDatasets();
            }
        })
    },

    beforeDestroy() {
        this.onResetDatasets();
    },
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/UserOnboarding/UserOnboarding.vue